import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import InfoBar from "./components/common/InfoBar";

import useArticleStore from './stores/useArticleStore';
import useFeedStore from './stores/useFeedStore';

function App() {
  const { fetchArticles } = useArticleStore();
  const { fetchFeeds } = useFeedStore();

  useEffect(() => {
    // 初始加载数据
    fetchArticles();
    fetchFeeds();
    
    // 设置定期刷新
    const interval = setInterval(() => {
      fetchArticles();
    }, 5 * 60 * 1000); // 每5分钟刷新一次
    
    return () => clearInterval(interval);
  }, [fetchArticles, fetchFeeds]);

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <InfoBar />
      <Header />
      <Box flex="1">
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
}

export default App;
